var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLiving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2208",
    transform: "translate(-519 -189)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 36",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(519 189)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 26.95v-2.7h9V21.1H8.95a1.35 1.35 0 1 1 0-2.7H13a2.689 2.689 0 0 1 2.7 2.7v3.15h4.95V10.93a6.644 6.644 0 0 1 2.05-4.905A6.755 6.755 0 0 1 27.625 4a6.655 6.655 0 0 1 3.6 1.012 6.914 6.914 0 0 1 2.52 2.768l1.89 3.78-2.475 1.215-1.845-3.735a4.409 4.409 0 0 0-1.552-1.688A3.954 3.954 0 0 0 27.58 6.7a4.225 4.225 0 0 0-4.23 4.23v13.32h4.95V21.1a2.689 2.689 0 0 1 2.7-2.7h4.05a1.35 1.35 0 1 1 0 2.7H31v3.15h9v2.7zm6.3 11.25a2.689 2.689 0 0 1-2.7-2.7v-8.55h2.7v8.55h23.4v-8.55h2.7v8.1a3.15 3.15 0 0 1-3.15 3.15z",
    transform: "translate(528 197.9)",
    style: {
      fill: "#ff731d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiving);
export default __webpack_public_path__ + "static/media/icon-living.bd855035.svg";
export { ForwardRef as ReactComponent };